<div>
  <div class="block-row">
    <div class="element-column left-side">
      <button id="btn_Seach" #btn_Seach [tabindex]="0" class="btn-secondary" forcedEnabledMode="true"
        (click)="eventSeach_CLICKHandler()">商品検索</button>
    </div>
  </div>

  <div class="display-right action-area">
    <app-pager [prevDisabled]="model.prevDisabled" [nextDisabled]="model.nextDisabled" [totalNum]="model.totalNum"
      [startNum]="model.startDispNum" [endNum]="model.endDispNum" (prevHandler)="eventPrev_CLICKHandler()"
      (nextHandler)="eventNext_CLICKHandler()">
    </app-pager>
  </div>
  <div>
    <wj-flex-grid id="dtg_MultiCodeList" #dtg_MultiCodeList [itemsSource]="model.multiCodeList"
      [headersVisibility]="'Column'" [selectionMode]="'Row'" [allowDragging]="'None'"
      [allowSorting]="false" [autoRowHeights]="true" forcedEnabledMode="true" [tabindex]="0">
      <wj-flex-grid-column [header]="'マルチコード'" [minWidth]="5" [width]="138" [binding]="'MultiCode'"
        [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'商品名'" [minWidth]="5" [width]="464" [binding]="'GuideGoodsName'"
        [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'規格名'" [minWidth]="5" [width]="300" [binding]="'GuideStandardName'"
        [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'メーカー'" [minWidth]="5" [width]="300" [binding]="'MakerName'"
        [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'支払先取引先'" [minWidth]="5" [width]="400" [binding]="'PayeeClient'"
        [isReadOnly]="true"></wj-flex-grid-column>
    </wj-flex-grid>
  </div>
</div>